import { render, staticRenderFns } from "./CompleteVerificationView.vue?vue&type=template&id=1da89a54&scoped=true"
import script from "./CompleteVerificationView.vue?vue&type=script&lang=js"
export * from "./CompleteVerificationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da89a54",
  null
  
)

export default component.exports